<!-- Read-only display of a submitted single-select answer's label. -->

<script lang="ts" setup>
import type { SingleSelectInputValue } from '@sigma/common/forms/SingleSelectInput.js';

interface Props {
  /** The single select answer value to display. */
  value: SingleSelectInputValue;
}

defineProps<Props>();
</script>

<template>
  {{ value.label }}
</template>
